<template>
  <div id="channelLogMain">
    <el-row>
      <el-col :span="24"
              class="titleLine">
        <el-breadcrumb separator-class="el-icon-arrow-right"
                       class="titleLine1">
          <el-breadcrumb-item>设备</el-breadcrumb-item>
          <el-breadcrumb-item>设备管理</el-breadcrumb-item>
          <el-breadcrumb-item>通道日志</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <el-row>
      <el-form :inline="true"
               style="height: 42px;"
               label-width="80px">
        <el-row>
          <el-col :span="24">
            <el-form-item label="客户::">
              <el-select v-model="pageSearch.fCustNo"
                         filterable
                         placeholder="请选择客户"
                         style="width:200px;"
                         @change="loadPark">
                <el-option v-for="item in cust_list"
                           :key="item.fCustNo"
                           :label="item.unionName"
                           :value="item.fCustNo">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="场库::">
              <el-select v-model="pageSearch.fParkID"
                         filterable
                         placeholder="请选择场库"
                         style="width:200px;"
                         @change="loadChannel"
                         clearable>
                <el-option v-for="item in park_list"
                           :key="item.fParkID"
                           :label="item.fParkName"
                           :value="item.fParkID">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="通道::">
              <el-select v-model="pageSearch.fChnlID"
                         filterable
                         placeholder="请选择通道"
                         style="width:200px;"
                         clearable>
                <el-option v-for="item in channel_list"
                           :key="item.fChnlID"
                           :label="item.fChnlName"
                           :value="item.fChnlID">
                </el-option>
              </el-select>
            </el-form-item>

          </el-col>
          <el-col :span="24">
            <el-form-item label="查询时间::">
              <el-date-picker v-model="pageSearch.fInTime"
                              type="datetime"
                              :clearable="false"
                              style="width:200px;"
                              placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="车牌::">
              <el-input placeholder="请输入车牌"
                        v-model="pageSearch.searchKeyWord"
                        class="search">
              </el-input>
            </el-form-item>
            <el-form-item label="">
              <el-button type="primary"
                         size="small"
                         icon="el-icon-search"
                         @click="page_list">查询</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-table :data="pageData"
                  :height="tableHeight"
                  highlight-current-row
                  v-loading="loading"
                  :row-class-name="tableRowClassName"
                  border
                  stripe
                  style="width: 100%">
          <el-table-column width="50"
                           type="index"
                           :index="indexMethod"
                           align="right"
                           label="序号">
          </el-table-column>
          <el-table-column prop="fCustNo"
                           label="客户编号"
                           width="80">
          </el-table-column>
          <el-table-column prop="fInTimeStr"
                           label="时间"
                           width="190">
          </el-table-column>
          <el-table-column prop="fParkName"
                           width="200"
                           label="场库">
          </el-table-column>
          <el-table-column prop="ChnlTypeName"
                           width="100"
                           label="通道类型">
          </el-table-column>
          <el-table-column prop="fChnlName"
                           width="100"
                           label="通道名称">
          </el-table-column>
          <el-table-column prop="fPlateCode"
                           width="100"
                           label="车牌号码">
          </el-table-column>
          <el-table-column prop="fModName"
                           width="150"
                           label="模块">
          </el-table-column>
          <el-table-column label="备注">
            <template slot-scope="scope">
              <el-tooltip placement="top">
                <div slot="content"
                     v-html="scope.row.fRemark"></div>
                <span>{{scope.row.fRemark}}</span>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row class="pagination">
      <el-col :span="24">
        <div class="block">
          <span class="demonstration"></span>
          <el-pagination @current-change="handleCurrentChange"
                         @size-change="handleSizeChange"
                         :current-page="pageSearch.pageIndex"
                         :page-size="pageSearch.pageSize"
                         :page-sizes="[10, 20, 50, 100]"
                         background
                         layout="total,sizes, prev, pager, next, jumper"
                         :total="pageCount"
                         v-if="pageCount>0">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { device } from '../../api/device'
import * as park from '../../api/park'
import * as user from '../../api/user'
export default {
  name: 'channelLogMain.vue',
  data () {
    return {
      is_export: false,
      pageData: [],
      cust_list: [],
      park_list: [],
      channel_list: [],
      loading: false,
      tableHeight: 0,
      pageCount: 0,
      pageSearch: {
        pageIndex: 1,
        pageSize: 20,
        fCustNo: '',
        fCustID: '',
        fParkID: '',
        fChnlID: '',
        fInTime: this.$dateFormat(new Date(), 'yyyy-MM-dd 00:00:00'),
        searchKeyWord: ''
      }
    }
  },
  methods: {
    page_list (index) {
      if (index && index >= 1) {
        this.pageSearch.pageIndex = index
      } else {
        this.pageSearch.pageIndex = 1
      }
      if ((this.pageSearch.fCustNo || '').length <= 0) {
        return
      }
      if (this.pageSearch.fInTime instanceof Date) {
        this.pageSearch.fInTime = this.$dateFormat(this.pageSearch.fInTime, 'yyyy-MM-dd hh:mm:ss')
      }
      this.loading = true
      device.channelLogList(this.pageSearch).then(res => {
        this.loading = false
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.pageData = data.Data.data
            this.pageCount = data.Data.count
          } else {
            this.$message.error('提示：' + data.Msg)
          }
        }
      })
    },
    loadPark (fCustNo) {
      this.pageSearch.fCustID = this.cust_list.find(r => { return r.fCustNo === fCustNo }).fCustID
      this.pageSearch.fInParkID = ''
      this.park_list = []
      this.pageSearch.fInChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!this.pageSearch.fCustID) { return }
      // 加载场库
      park.getParkList({ fCustID: this.pageSearch.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.park_list = data.Data || []
            // if (this.park_list && this.park_list.length > 0) {
            //   this.pageSearch.fInParkID = this.park_list[0].fParkID
            //   this.loadChannel(this.pageSearch.fInParkID)
            // }
          } else {
            this.$message.error('提示：加载场库列表失败')
          }
        }
      })
    },
    loadChannel (fInParkID) {
      this.pageSearch.fInChnlID = ''
      this.channel_list = []
      // 加载在场数据列表
      // this.page_list()
      if (!fInParkID) { return }
      // 加载通道
      park.channelList({ fParkID: fInParkID, fCustID: this.pageSearch.fCustID }).then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.channel_list = data.Data || []
            // console.log(this.channel_list)
            // if (this.channel_list && this.channel_list.length > 0) {
            //   this.pageSearch.fInChnlID = this.channel_list[0].fChnlID
            // }
          } else {
            this.$message.error('提示：加载通道列表失败')
          }
        }
      })
    },
    init () {
      park.getCustByGroup().then(res => {
        if (res && res.data) {
          var data = res.data
          if (data.IsOk) {
            this.cust_list = data.Data
            // if (this.cust_list && this.cust_list.length > 0) {
            //   this.pageSearch.fCustID = this.cust_list[0].fCustID
            //   this.loadPark(this.pageSearch.fCustID)
            // }
          } else {
            this.$message.error('提示：加载客户列表失败')
          }
        }
      })
    },
    indexMethod (index) {
      return this.pageSearch.pageSize * (this.pageSearch.pageIndex - 1) + index + 1
    },
    handleSizeChange (val) {
      this.pageSearch.pageSize = val
      this.page_list(this.pageSearch.pageIndex)
    },
    handleCurrentChange (val) {
      this.page_list(val)
    },
    tableRowClassName ({ row, rowIndex }) {
      if (row.fBatchID === '1') {
        return 'warning-row'
      }
      return ''
    },
    setTableHeight (obj) {
      let clientHeight = obj.getRJPageSize.getRJPageSize()[3] - 260
      obj.tableHeight = clientHeight
    }
  },
  created () {
    user.getCurrentUserPers({ perTypeId: 72000 }).then(res => {
      if (res && res.data) {
        var data = res.data
        if (data.IsOk) {
          if (data.Data) {
            this.is_export = data.Data.data.is_export
          }
        } else {
          this.$message.error('提示：加载当前用户权限信息失败')
        }
      }
    })
  },
  mounted () {
    window.onresize = () => {
      this.setTableHeight(this)
    }
    this.init()
  },
  updated () {
    this.setTableHeight(this)
  }
}
</script>

<style>
#channelLogMain .warning-row {
  color: blue;
}
#channelLogMain .tip span {
  padding-right: 10px;
  font-weight: bold;
  color: #ccc;
}
#channelLogMain .tip span.msg_value {
  padding-right: 0px;
  color: darkseagreen;
}
</style>
<style scoped>
.el-form-item {
  margin-bottom: 10px;
}
.pagination {
  text-align: right;
  padding-top: 5px;
}
.search {
  width: 200px;
}
.tip {
  text-align: center;
  position: absolute;
  top: 12px;
  right: 40px;
}
.log_search {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// src/view/device/channelLogMain.vue